import { useContext, useMemo } from 'react';
import { TitanRouterContext } from '../context/TitanRouterContext.js';

const useTitanRouter = () => {
  const context = useContext(TitanRouterContext);
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context === undefined) {
    throw new Error('useTitanTheme must be used within a ThemeProvider');
  }
  const {
    useLinkWrapper,
    useLinkResolver
  } = context;
  const linkWrapper = useLinkWrapper();
  const linkResolver = useLinkResolver();
  return useMemo(() => ({
    linkWrapper,
    linkResolver,
    defaultYOffset: context.defaultYOffset
  }), [context.defaultYOffset, linkResolver, linkWrapper]);
};

export { useTitanRouter };
//# sourceMappingURL=useTitanRouter.js.map
